//App.js
import React from "react";
import Counter from "./components/Counter";

const App = () => {
  return <Counter />;
};

export default App;